import React, { useState, useEffect } from 'react';

// Importation des étapes
import StepTypeClient from './steps/StepTypeClient';
import StepIdentite from './steps/StepIdentite';
import StepContact from './steps/StepContact';
import StepNationalite from './steps/StepNationalite';
import StepAdresse from './steps/StepAdresse';
import StepSituationLogement from './steps/StepSituationLogement';
import StepSituationPro from './steps/StepSituationPro';
import StepRevenusMensuels from './steps/StepRevenusMensuels';
import StepDepensesMensuelles from './steps/StepDepensesMensuelles';
import StepFinal from './steps/StepFinal';

const OrpiForm = () => {
  // État initial du formulaire avec des champs mis à jour
  const [formData, setFormData] = useState(
    {
    typeClient: '', 
    civilite: '',
    prenom: '',
    nom: '',
    dateNaissance: '',
    email: '',
    telephoneContact: '', 
    nationalite: '',
    autreNationalite: '',
    paysNaissance: '',
    villeNaissance: '',
    adresse: '',
    codePostal: '',
    ville: '',
    situationLogement: '',
    situationLogementAutre: '',  // Pour préciser "autre" situation de logement
    organismePreteur: '',        // Pour propriétaire avec prêt
    dateFinPret: '',             // Pour propriétaire avec prêt
    dateEntreeLogement: '',
    situationFamiliale: '',
    
    // Champs pour le conjoint (dans StepIdentite)
    prenomConjoint: '',
    nomConjoint: '',
    dateNaissanceConjoint: '',
    
    // Champs pour la situation professionnelle (nouvelle version)
    secteurActivite: '',        // Secteur d'activité (prive, public, agricole, etc.)
    profession: '',             // Profession sélectionnée
    dateEntreeEntreprise: '',   // Date d'entrée chez l'employeur ou début de la situation
    
    // Champs pour la situation professionnelle (ancienne version - conservés pour compatibilité)
    typeContrat: '', 
    employeur: '',
    typeContratAutre: '',
    dateFinContrat: '',
    
    revenusNets: '',
    allocationsCaf: '',
    pensionAlimentaire: '',
    autresRevenus: '',
    autresRevenusDescription: '',
    loyerActuel: '',
    chargesCopro: '',
    electriciteGaz: '',
    eau: '',
    internetAbonnement: '',
    assurances: '',
    autresCharges: '',
    banque: '',
    autreBanque: '',
    depuis: '',
    typeIdentite: '',
    pieceIdentiteFile: null,
    
    // État de consentement
    consentement: false,
  }
//   {
//     "typeClient": "locataire",
//     "civilite": "Monsieur",
//     "prenom": "ter",
//     "nom": "terte",
//     "dateNaissance": "1993-06-08",
//     "email": "test@gmail.com",
//     "telephoneContact": "3457623464",
//     "nationalite": "Française",
//     "autreNationalite": "",
//     "paysNaissance": "France",
//     "villeNaissance": "fdgdfg",
//     "adresse": "fsdf 324 sd fdg",
//     "codePostal": "52110",
//     "ville": "Am Marktplatz",
//     "situationLogement": "proprietaire_sans_pret",
//     "situationLogementAutre": "",
//     "organismePreteur": "",
//     "dateFinPret": "",
//     "dateEntreeLogement": "2025-07-01",
//     "situationFamiliale": "Marié(e)",
//     "prenomConjoint": "tert",
//     "nomConjoint": "ertert",
//     "dateNaissanceConjoint": "2005-01-30",
//     "secteurActivite": "prive",
//     "profession": "Agent de sécurité",
//     "dateEntreeEntreprise": "2024-10-08",
//     "typeContrat": "Saisonnier",
//     "employeur": "",
//     "typeContratAutre": "",
//     "dateFinContrat": "",
//     "revenusNets": "563",
//     "allocationsCaf": "",
//     "pensionAlimentaire": "",
//     "autresRevenus": false,
//     "autresRevenusDescription": "",
//     "loyerActuel": "345345",
//     "chargesCopro": "",
//     "electriciteGaz": "",
//     "eau": "",
//     "internetAbonnement": "",
//     "assurances": "",
//     "autresCharges": "",
//     "banque": "lcl",
//     "autreBanque": "",
//     "depuis": "",
//     "typeIdentite": "titre",
//     "pieceIdentiteFile": null,
//     "consentement": false,
//     "aGarant": "non",
//     "nomNaissance": "t",
//     "paysNaissanceAutre": "",
//     "villeNaissanceAutre": "",
//     "complementAdresse": "dfgd",
//     "remboursementSecondaire": "4534",
//     "creditConso": "345",
//     "nomPreteurs": "dfgdfg",
//     "pensionsVersees": "345345",
//     "anneeOuvertureCompte": "2011"
// }
);

  // Navigation et UI
  const [currentStep, setCurrentStep] = useState(1);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  // Définition des étapes de la sidebar - Suppression de StepBanque
  const sidebarSteps = [
    { id: 1, name: 'Type de client', component: StepTypeClient },
    { id: 2, name: 'Identité', component: StepIdentite },
    { id: 3, name: 'Contact', component: StepContact },
    { id: 4, name: 'Nationalité', component: StepNationalite },
    { id: 5, name: 'Adresse postale', component: StepAdresse },
    { id: 6, name: 'Situation de logement', component: StepSituationLogement },
    { id: 7, name: 'Situation professionnelle', component: StepSituationPro },
    { id: 8, name: 'Revenus mensuels', component: StepRevenusMensuels },
    { id: 9, name: 'Dépenses mensuelles', component: StepDepensesMensuelles },
    { id: 10, name: 'Validation et documents', component: StepFinal },
  ];

  // Utilisation de useEffect pour le logging
  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  // Fonction pour gérer les changements dans le formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  // Détermine quelle étape afficher
  const getCurrentStepComponent = () => {
    // Retourne simplement l'étape correspondante
    const stepIndex = currentStep - 1;
    if (stepIndex >= 0 && stepIndex < sidebarSteps.length) {
      return sidebarSteps[stepIndex].component;
    }
    
    return null;
  };

  // Navigation - Fonction pour aller à l'étape suivante
  const handleNext = () => {
    console.log('Tentative de passage à l\'étape suivante...');
    
    if (!validateStep(currentStep)) {
      return;
    }

    // Navigation standard
    setCurrentStep(currentStep + 1);
    
    // Réinitialiser l'erreur pour l'étape suivante
    setError('');
    
    // Faire défiler vers le haut de la page
    window.scrollTo(0, 0);
  };

  // Navigation - Fonction pour revenir à l'étape précédente
  const handlePrevious = () => {
    // Navigation standard vers l'arrière
    setCurrentStep(currentStep - 1);
    
    // Réinitialiser l'erreur
    setError('');
    
    // Faire défiler vers le haut de la page
    window.scrollTo(0, 0);
  };

  // Gestion de la soumission finale du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Dernière validation avant soumission
    if (!validateStep(currentStep)) {
      return;
    }
    
    // Afficher les données complètes dans la console
    console.log('Form Data Submitted:', formData);
    
    // Marquer le formulaire comme soumis pour afficher le message de succès
    setSubmitted(true);
    
    // Ici, vous pourriez implémenter l'appel API pour envoyer les données
    // fetch('votre-api-endpoint', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(formData)
    // })
    // .then(response => response.json())
    // .then(data => {
    //   console.log('Success:', data);
    //   setSubmitted(true);
    // })
    // .catch(error => {
    //   console.error('Error:', error);
    //   setError('Une erreur est survenue lors de l\'envoi du formulaire. Veuillez réessayer.');
    // });
  };
  
  // Validation des formulaires à chaque étape
  const validateStep = (step) => {
    console.log(`Validating step ${step} with data:`, formData);
    setError('');

    switch (step) {
      // Fonction de validation à mettre à jour dans OrpiForm.js
      // Remplacer le case 1 actuel par cette version améliorée:

      case 1: // StepTypeClient
      if (!formData.typeClient) {
        setError('Veuillez sélectionner votre statut (locataire ou garant)');
        return false;
      }

      // Validation supplémentaire pour les locataires
      if (formData.typeClient === 'locataire') {
        // Vérifier si la réponse à "Avez-vous un garant" est donnée
        if (formData.aGarant !== 'oui' && formData.aGarant !== 'non') {
          setError('Veuillez indiquer si vous avez un garant');
          return false;
        }
        
        // Si la réponse est "oui", vérifier que le nom du garant est renseigné
        if (formData.aGarant === 'oui' && (!formData.nomGarant || formData.nomGarant.trim() === '')) {
          setError('Veuillez indiquer le nom du garant');
          return false;
        }
      }

      // Validation supplémentaire pour les garants
      if (formData.typeClient === 'garant' && (!formData.nomLocataire || formData.nomLocataire.trim() === '')) {
        setError('Veuillez indiquer le nom du locataire pour lequel vous êtes garant');
        return false;
      }

      return true;;

      case 2: // StepIdentite
        if (!formData.civilite || !formData.prenom || !formData.nom || !formData.situationFamiliale) {
          setError('Veuillez remplir tous les champs obligatoires');
          return false;
        }
        
        // Vérification du champ "Depuis quand ?" si nécessaire
        if (['Marié(e)', 'Pacsé(e)', 'Concubinage'].includes(formData.situationFamiliale)) {
          if (!formData.depuisQuandSituationFamiliale) {
            setError('Veuillez renseigner la date "Depuis quand ?" pour votre situation familiale');
            return false;
          }
        }
        
        // Vérifier l'âge seulement si la date est renseignée
        if (formData.dateNaissance) {
          try {
            const birthDate = new Date(formData.dateNaissance);
            if (isNaN(birthDate.getTime())) {
              console.warn('Date de naissance invalide:', formData.dateNaissance);
              return true;
            }
            
            const today = new Date();
            const age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            
            // Ajuster l'âge si l'anniversaire n'est pas encore passé
            const realAge = (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
              ? age - 1 
              : age;
              
            if (realAge < 18) {
              setError('Vous devez avoir au moins 18 ans pour faire une demande');
              return false;
            }
            
            if (realAge > 99) {
              setError('L\'âge maximum accepté est de 99 ans');
              return false;
            }
          } catch (error) {
            console.error('Erreur lors de la validation de la date:', error);
            return true;
          }
        }
        return true;

      case 3: // StepContact
        if (!formData.email || !formData.telephoneContact) {
          setError('Veuillez remplir tous les champs');
          return false;
        }
        
        // Validation email simple
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
          setError('Veuillez entrer une adresse email valide');
          return false;
        }
        
        // Validation téléphone simple
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(formData.telephoneContact.replace(/\s/g, ''))) {
          setError('Veuillez entrer un numéro de téléphone valide (10 chiffres)');
          return false;
        }
        return true;

      case 4: // StepNationalite
        if (!formData.nationalite) {
          setError('Veuillez sélectionner votre nationalité');
          return false;
        }
        
        if (formData.nationalite === 'Autre' && !formData.nationaliteAutre) {
          setError('Veuillez préciser votre nationalité');
          return false;
        }
        
        if (formData.paysNaissance === 'Autre' && (!formData.paysNaissanceAutre || !formData.villeNaissanceAutre)) {
          setError('Veuillez préciser votre pays et ville de naissance');
          return false;
        }
        return true;

      case 5: // StepAdressePostale
        if (!formData.adresse || !formData.codePostal || !formData.ville) {
          setError('Veuillez remplir tous les champs d\'adresse');
          return false;
        }
        
        // Validation simple du code postal français
        const cpRegex = /^[0-9]{5}$/;
        if (!cpRegex.test(formData.codePostal.replace(/\s/g, ''))) {
          setError('Veuillez entrer un code postal valide (5 chiffres)');
          return false;
        }
        return true;

      case 6: // StepSituationLogement
        if (!formData.situationLogement) {
          setError('Veuillez sélectionner votre situation de logement');
          return false;
        }
        
        // Validation des champs supplémentaires selon la situation
        if (formData.situationLogement === 'autre' && !formData.situationLogementAutre) {
          setError('Veuillez préciser votre situation de logement');
          return false;
        }
        
        if (formData.situationLogement === 'proprietaire_avec_pret') {
          if (!formData.organismePreteur) {
            setError('Veuillez indiquer l\'organisme prêteur');
            return false;
          }
          if (!formData.dateFinPret) {
            setError('Veuillez indiquer la date de fin du prêt');
            return false;
          }
        }
        
        if (!formData.dateEntreeLogement) {
          setError('Veuillez indiquer la date d\'entrée dans votre logement');
          return false;
        }
        return true;

      case 7: // StepSituationPro - NOUVELLE VALIDATION
        if (!formData.secteurActivite) {
          setError('Veuillez sélectionner un secteur d\'activité');
          return false;
        }
        
        if (!formData.profession) {
          setError('Veuillez sélectionner une profession ou une situation');
          return false;
        }
        
        if (!formData.dateEntreeEntreprise) {
          setError('Veuillez indiquer la date de début de votre situation actuelle');
          return false;
        }
        
        return true;

      case 8: // StepRevenusMensuels
        // Vérification du salaire mensuel
        if (!formData.revenusNets || isNaN(parseFloat(formData.revenusNets)) || parseFloat(formData.revenusNets) <= 0) {
          setError('Veuillez indiquer un montant valide pour vos revenus mensuels nets');
          return false;
        }
        
        // Vérification de la sélection oui/non pour les revenus supplémentaires
        if (formData.autresRevenus !== true && formData.autresRevenus !== false) {
          setError('Veuillez indiquer si vous avez des revenus supplémentaires');
          return false;
        }
        
        // Si l'utilisateur a des revenus supplémentaires, tous les champs deviennent obligatoires
        if (formData.autresRevenus === true) {
          // Vérifier que tous les champs numériques sont remplis (même avec 0)
          const requiredFields = [
            { name: 'pensionAlimentaire', label: 'Pensions' },
            { name: 'allocationsCaf', label: 'Allocations familiales' },
            { name: 'revenusFonciers', label: 'Revenus fonciers' },
            { name: 'autresRevenusDescription', label: 'Autres revenus' }
          ];
          
          for (const field of requiredFields) {
            // Vérifier si le champ est vide ou n'est pas un nombre
            if (
              formData[field.name] === undefined || 
              formData[field.name] === '' || 
              isNaN(parseFloat(formData[field.name]))
            ) {
              setError(`Veuillez remplir le champ "${field.label}" (mettez 0 si non applicable)`);
              return false;
            }
          }
          
          // Si "autres revenus" est renseigné avec un montant > 0, la nature doit être précisée
          if (
            formData.autresRevenusDescription && 
            parseFloat(formData.autresRevenusDescription) > 0 && 
            (!formData.autresRevenusNature || formData.autresRevenusNature.trim() === '')
          ) {
            setError('Veuillez préciser la nature de vos autres revenus');
            return false;
          }
        }
        
        return true;

      // Modifiez la validation pour l'étape 9 (StepDepensesMensuelles) dans la fonction validateStep de OrpiForm.js

      
      case 9: // StepDepensesMensuelles
        // Liste des champs à vérifier
        const requiredExpenses = [
          { name: 'loyerActuel', label: 'Loyer / remboursement résidence principale' },
          { name: 'remboursementSecondaire', label: 'Remboursement résidence secondaire' },
          { name: 'creditConso', label: 'Crédits conso en cours' },
          { name: 'pensionsVersees', label: 'Pension(s) alimentaire(s) versée(s)' }
        ];

        // Vérifier si chaque champ de dépense est soit rempli avec un nombre, soit marqué "Aucun"
        for (const field of requiredExpenses) {
          // On doit vérifier si le champ a une valeur OU si le bouton "Aucun" est sélectionné
          // Le bouton "Aucun" est équivalent à une chaîne vide dans notre implémentation
          
          // Si le champ n'a pas de valeur définie du tout dans formData
          if (formData[field.name] === undefined) {
            setError(`Veuillez renseigner le champ "${field.label}" ou sélectionner "Aucun"`);
            return false;
          }
          
          // Cas spécial pour le loyer: si l'utilisateur est propriétaire sans prêt,
          // on accepte que le loyer soit vide (équivalent à "Aucun")
          if (field.name === 'loyerActuel') {
            if (formData.situationLogement === 'proprietaire_sans_pret' && formData[field.name] === '') {
              // C'est OK, on continue
              continue;
            }
            
            // Si l'utilisateur est locataire ou propriétaire avec prêt, le montant doit être > 0
            else if ((formData.situationLogement === 'proprietaire_avec_pret' || formData.situationLogement === 'locataire')) {
              // Si la valeur est vide (pas d'Aucun sélectionné)
              if (formData[field.name] === '') {
                setError(`Le montant du loyer ou remboursement de prêt est obligatoire pour les locataires ou propriétaires avec prêt.`);
                return false;
              }
              
              // Si la valeur n'est pas un nombre valide > 0
              const value = parseFloat(formData[field.name]);
              if (isNaN(value) || value <= 0) {
                setError(`Le montant du loyer ou remboursement de prêt doit être supérieur à 0€ pour les locataires ou propriétaires avec prêt.`);
                return false;
              }
            }
          }
          
          // Si le champ a une valeur vide, c'est acceptable (cela signifie que "Aucun" est sélectionné)
          if (formData[field.name] === '') {
            continue; // C'est OK, on passe au champ suivant
          }
          
          // Si le champ a une valeur qui n'est pas un nombre valide
          const value = parseFloat(formData[field.name]);
          if (isNaN(value) || value < 0) {
            setError(`Veuillez indiquer un montant valide pour "${field.label}" ou sélectionner "Aucun"`);
            return false;
          }
        }

        // Vérifier si le crédit conso a une valeur > 0, alors le nom des prêteurs est obligatoire
        const creditConsoValue = parseFloat(formData.creditConso) || 0;

        if (creditConsoValue > 0 && (!formData.nomPreteurs || formData.nomPreteurs.trim() === '')) {
          setError('Veuillez préciser le nom du ou des prêteurs pour vos crédits');
          return false;
        }

        // Validation de la banque et de l'année
        if (!formData.banque) {
          setError('Veuillez sélectionner votre banque');
          return false;
        }

        if (formData.banque === 'autre' && (!formData.autreBanque || formData.autreBanque.trim() === '')) {
          setError('Veuillez préciser le nom de votre banque');
          return false;
        }

        if (!formData.anneeOuvertureCompte) {
          setError('Veuillez sélectionner l\'année d\'ouverture de votre compte');
          return false;
        }

        return true;

      case 10: // StepFinal (avec validation des documents)
        // La validation est désormais gérée dans le composant StepFinal lui-même
        return true;

      default:
        return true;
    }
  };

  // Rendu du composant actuel pour l'étape courante
  const CurrentStepComponent = getCurrentStepComponent();

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Stepper Header */}
      <div className="flex flex-col md:flex-row justify-between mb-8">
        <div className="hidden md:block w-full md:w-1/4 mb-6 md:mb-0">
          <div className="bg-white p-4 rounded shadow">
            <h3 className="font-semibold text-lg mb-4 text-orpi-primary">Étapes</h3>
            <ul className="space-y-2">
              {sidebarSteps.map((step) => (
                <li
                  key={step.id}
                  className={`p-2 rounded ${
                    currentStep === step.id
                      ? 'bg-orpi-primary text-white'
                      : currentStep > step.id
                      ? 'bg-gray-100 text-gray-700'
                      : 'text-gray-500'
                  }`}
                >
                  {step.name}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Form Content */}
        <div className="w-full md:w-3/4 md:pl-8">
          <div className="bg-white p-6 rounded shadow">
            {submitted ? (
              <div className="text-center py-8">
                <h2 className="text-2xl font-bold text-green-600 mb-4">Formulaire envoyé avec succès !</h2>
                <p className="mb-4">
                  Merci d'avoir complété votre dossier. Nous l'examinerons dans les plus brefs délais.
                </p>
                <p>Un email de confirmation a été envoyé à l'adresse {formData.email}.</p>
              </div>
            ) : CurrentStepComponent ? (
              <form onSubmit={handleSubmit}>
                {error && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {error}
                  </div>
                )}

                <CurrentStepComponent formData={formData} onChange={handleChange} />

                <div className="mt-8 flex justify-between">
                  {currentStep > 1 && (
                    <button
                      type="button"
                      onClick={handlePrevious}
                      className="px-6 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-100"
                    >
                      Retour
                    </button>
                  )}

                  {currentStep < sidebarSteps.length ? (
                    <button
                      type="button"
                      onClick={handleNext}
                      className="px-6 py-2 bg-orpi-primary text-white rounded hover:bg-orpi-dark"
                    >
                      Suivant
                    </button>
                  ) : (
                    // Ne pas afficher de bouton "Envoyer mon dossier" sur la dernière étape
                    // car le bouton "Finaliser ma demande" est déjà géré par StepFinal
                    <div></div>
                  )}
                </div>
              </form>
            ) : (
              <div>Étape non trouvée</div>
            )}

            {/* Legal footer */}
            <div className="mt-8 pt-4 border-t text-xs text-gray-500">
              <p>En soumettant ce formulaire, vous acceptez que vos données soient traitées conformément à notre politique de confidentialité.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrpiForm;